
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34","height":"32","width":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"fill-rule":"nonzero","fill":"#000"}},[_c('path',{attrs:{"fill-opacity":".85","d":"M16 3.698c4.708 0 9.412 2.763 14.117 8.218l.49.568-1.136.98-.003-.004-8.669 8.353a5.018 5.018 0 11-9.6.003L2 13.006l-.606-.522.49-.568C6.588 6.461 11.292 3.698 16 3.698zm0 1.5c-4.057 0-8.228 2.366-12.509 7.16l9.104 8.717a.75.75 0 01.206.738l.002-.001-.002.003-.01.025-.07.167a3.518 3.518 0 106.567.02.716.716 0 01.104-.914l9.102-8.772C24.219 7.558 20.052 5.198 16 5.198z","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"11.821","cx":"9.537","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"9.942","cx":"14.816","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"12.371","cx":"23.575","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"14.936","cx":"13.731","vector-effect":"non-scaling-stroke"}})])])])
          )
        }
      }
    